<template>
    <div class="gallery-item" :class="[rootClasses]">
        <cmp-tinted-image facet="gallery-image"
                :is-inert="false"
                :img="preview"
                @request-action="onGalleryRequested('image')">
        </cmp-tinted-image>

         <!--<pre v-if="content" v-text="content"></pre>-->
    </div>
</template>

<script>
    import galleryItemMixin from 'framework/mixins/gallery-item';


    export default {
        mixins: [
            galleryItemMixin,
        ],
    };
</script>



// WEBPACK FOOTER //
// vehi-industriepfad/assets/src/js/app/framework/components/cms-plugins/gallery-image/index.vue?1b931a1a